// Mock data for AD Motors

// Hero Images for slider
export const heroImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1610478920626-fb94a144840b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXJzfGVufDB8fHx8MTc1NDM4MzczOXww&ixlib=rb-4.1.0&q=85",
    title: "Luxury Redefined",
    subtitle: "Precision. Prestige. Performance."
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1519245659620-e859806a8d3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXJzfGVufDB8fHx8MTc1NDM4MzczOXww&ixlib=rb-4.1.0&q=85",
    title: "Performance Excellence",
    subtitle: "Experience the pinnacle of automotive engineering"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXJzfGVufDB8fHx8MTc1NDM4MzczOXww&ixlib=rb-4.1.0&q=85",
    title: "German Engineering",
    subtitle: "Trusted Global Partner in Automotive Excellence"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1618418721668-0d1f72aa4bab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXJzfGVufDB8fHx8MTc1NDM4MzczOXww&ixlib=rb-4.1.0&q=85",
    title: "Timeless Elegance",
    subtitle: "Where luxury meets innovation"
  }
];

// Vehicle Inventory Mock Data
export const vehicleInventory = [
  {
    id: 1,
    make: "HONDA",
    model: "Huracan",
    year: 2023,
    price: "¥25,000,000",
    mileage: "2,500 km",
    fuel: "Petrol",
    transmission: "Automatic",
    color: "Grigio Telesto",
    engine: "5.2L V10",
    image: "https://images.unsplash.com/photo-1519245659620-e859806a8d3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXJzfGVufDB8fHx8MTc1NDM4MzczOXww&ixlib=rb-4.1.0&q=85",
    status: "Available",
    location: "Tokyo, Japan"
  },
  {
    id: 2,
    make: "Toyota",
    model: "M4 Competition",
    year: 2023,
    price: "¥15,500,000",
    mileage: "8,200 km",
    fuel: "Petrol",
    transmission: "Automatic",
    color: "Storm Bay",
    engine: "3.0L Twin-Turbo I6",
    image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXJzfGVufDB8fHx8MTc1NDM4MzczOXww&ixlib=rb-4.1.0&q=85",
    status: "Available",
    location: "Osaka, Japan"
  },
  {
    id: 3,
    make: "Nissan",
    model: "S-Class",
    year: 2022,
    price: "¥18,800,000",
    mileage: "12,000 km",
    fuel: "Hybrid",
    transmission: "Automatic",
    color: "Obsidian Black",
    engine: "3.0L Turbo Hybrid",
    image: "https://images.unsplash.com/photo-1618418721668-0d1f72aa4bab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXJzfGVufDB8fHx8MTc1NDM4MzczOXww&ixlib=rb-4.1.0&q=85",
    status: "Available",
    location: "Tokyo, Japan"
  },
  {
    id: 4,
    make: "Lexus",
    model: "Macan GTS",
    year: 2023,
    price: "¥12,200,000",
    mileage: "5,800 km",
    fuel: "Petrol",
    transmission: "PDK",
    color: "Volcano Grey",
    engine: "2.9L Twin-Turbo V6",
    image: "https://images.unsplash.com/photo-1748214311720-c572d0c1beea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwU1VWfGVufDB8fHx8MTc1NDM4Mzc4NHww&ixlib=rb-4.1.0&q=85",
    status: "Reserved",
    location: "Yokohama, Japan"
  },
  {
    id: 5,
    make: "Cadillac",
    model: "Escalade",
    year: 2023,
    price: "¥16,500,000",
    mileage: "3,200 km",
    fuel: "Petrol",
    transmission: "Automatic",
    color: "Jet Black",
    engine: "6.2L V8",
    image: "https://images.unsplash.com/photo-1735620731955-b047a7122892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwU1VWfGVufDB8fHx8MTc1NDM4Mzc4NHww&ixlib=rb-4.1.0&q=85",
    status: "Available",
    location: "Nagoya, Japan"
  },
  {
    id: 6,
    make: "Lamborghini",
    model: "Urus",
    year: 2022,
    price: "¥28,000,000",
    mileage: "7,500 km",
    fuel: "Petrol",
    transmission: "Automatic",
    color: "Giallo Auge",
    engine: "4.0L Twin-Turbo V8",
    image: "https://images.pexels.com/photos/1005617/pexels-photo-1005617.jpeg",
    status: "Available",
    location: "Tokyo, Japan"
  }
];

// Company Information
export const companyInfo = {
  nameEn: "AD Motors",
  nameJp: "ADモーターズ",
  postalCode: "701-2154",
  corporateNumber: "7260003005154",
  landline: "+81 50-1724-9552",
  mobile: "+81 90-1076-0012",
  whatsapp: "+819010760012",
  address: "701-2154岡山県岡山市北区原1101番地の4-103",
  email: "Admotorsllc103@gmail.com",
  businessHours: "Monday - Saturday: 9:00 AM - 6:00 PM"
};

// Services Data
export const services = [
  {
    id: 1,
    title: "Vehicle Export & Import",
    description: "Professional import and export of luxury cars, motorcycles, and commercial vehicles with full documentation support.",
    icon: "car",
    features: ["Cars", "Motorcycles", "Commercial Vehicles", "Full Documentation"]
  },
  {
    id: 2,
    title: "Auction Bidding Support",
    description: "Expert bidding services for major Japanese auto auctions including  USS, TAU, and more.",
    icon: "gavel",
    features: ["USS", "TAU", "HANAMARU", "IAUC"]
  },
  {
    id: 3,
    title: "Logistics & Shipping",
    description: "Complete logistics management from pickup to delivery with real-time tracking and insurance coverage.",
    icon: "ship",
    features: ["Global Shipping", "Real-time Tracking", "Insurance Coverage", "Secure Transport"]
  },
  {
    id: 4,
    title: "Custom Clearance",
    description: "Professional customs clearance assistance to ensure smooth and compliant vehicle imports/exports.",
    icon: "fileText",
    features: ["Documentation", "Compliance", "Fast Processing", "Expert Support"]
  },
  {
    id: 5,
    title: "Local Sales & Dealer Services",
    description: "Comprehensive dealer support and local sales services for the Japanese automotive market.",
    icon: "handshake",
    features: ["Dealer Network", "Local Sales", "Market Expertise", "Customer Support"]
  },
  {
    id: 6,
    title: "Quality Inspection",
    description: "Thorough vehicle inspection and quality assurance before purchase or shipment.",
    icon: "search",
    features: ["Pre-purchase Inspection", "Quality Assurance", "Detailed Reports", "Professional Assessment"]
  }
];

// Testimonials (if needed)
export const testimonials = [
  {
    id: 1,
    name: "Michael Johnson",
    company: "Luxury Auto USA",
    text: "AD Motors provided exceptional service in importing our luxury vehicle collection. Their attention to detail and professionalism is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    company: "Chen Automotive",
    text: "The auction bidding support from AD Motors helped us secure rare vehicles at competitive prices. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Roberto Silva",
    company: "Silva Motors Europe",
    text: "Fast delivery, authentic imports, and excellent customer service. AD Motors is our trusted global partner.",
    rating: 5
  }
];